if (window.location.href.includes("/loyalty")) {
  const urlParams = new URLSearchParams(window.location.search);
  const email = urlParams.get("email");

  if (email) {
    console.log("Email:", email);

    const emailInput = document.getElementById("email");
    if (emailInput) {
      emailInput.value = email;
    }
  } else {
    console.log("Email parameter not found in the URL.");
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('newsletter-footer');

  if (!form) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    const emailInput = form.querySelector('input[name="contact[email]"]');
    const email = emailInput ? emailInput.value.trim() : '';

    if (!email) {
      emailInput.focus();
      return;
    }

    window.location.href = '/a/loyalty?email=' + encodeURIComponent(email);
  });
});